import ReduxState from "../state";

type State = ReduxState["sponsor"];

const initialState: State = null;

export default function sponsorReducer(state: State = initialState): State {
  return state;
}
